import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_ray6dg7csp: FaireCollectionEntity = {
  token: "pbc_ray6dg7csp",
  type: "collection",
  name: "Pretty in Pink 🌸🎀",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9174b1ec50170646a6807fc30b456d5c5c53821291851e6d99b67b1ae890e1e8.jpeg",
  itemCount: 38,
  description:
    "Think pink! Our Pretty in Pink Collection is filled with sweet, playful styles designed for little ones who love all things pink. From charming dresses and twirl-worthy skirts to adorable graphic tees, cozy sweatshirts, and fun accessories, each piece adds a touch of sparkle!",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:37.661Z",
    importedBy: "entity-db-import-collections",
  },
};
